import { createClient } from "@supabase/supabase-js";
import { Database } from "./database.types";
import config from "./config";

const supabase = createClient<Database>(config.supabaseUrl, config.supabaseApiKey);

// eslint-disable-next-line import/prefer-default-export
export { supabase };
